import { forwardRef, type ComponentPropsWithoutRef } from "react";
import { TextField } from "@mui/material";
import type { TextFieldProps } from "@mui/material";

type GlobalInputProps = Omit<TextFieldProps, "size" | "variant">;

export function GlobalInput(props: GlobalInputProps) {
  return <TextField {...props} size="medium" variant="outlined" />;
}

export const GlobalFileInput = forwardRef<
  HTMLInputElement,
  ComponentPropsWithoutRef<"input">
>(function GlobalFileInput(props, ref) {
  return <input {...props} ref={ref} hidden type="file" />;
});
